import { request } from '../request'

/**
 * 获取已经删除的文件列表
 * @param params
 * @return {Promise}
 */
export function getRecycleList(params) {
  return request({
    url: 'wenjuan/wjsurvey/getSurveyListOfRecycle',
    method: 'get',
    params
  })
}

//获取下载答卷来源进度概览页面数据
export function getSourceProgress(surveyId) {
  return request({
    url: '/answer/qualityControl/getSourceProgress/' + surveyId,
    method: 'get'
  })
}
